import { isAxiosError } from "axios";

interface ApiErrorBody {
  detail?: string | { msg: string }[];
  message?: string;
}

export const GetErrorMessage = (error: unknown, fallback: string): string =>
  (error instanceof Error && error.message) || fallback;

export const GetApiErrorMessage = (error: unknown, fallback: string): string => {
  const body = isAxiosError<ApiErrorBody>(error) ? error.response?.data : undefined;
  const message = body?.detail || body?.message || GetErrorMessage(error, fallback);

  return Array.isArray(message)
    ? message.map(item => item.msg).join(", ")
    : message.replace(/^\d+:\s*/, "").trim();
};
